import { useState } from "react";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { object, string } from "yup";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import { CloseButton } from "components/CloseButton";
import { MySpinner } from "components/MySpinner";
import { SelectSearch } from "components/SelectSearch";
import { brandsSuggestion, createCross } from "services/api";

const CrossSchema = object().shape({
  article: string().required(),
  brand: object().required()
});

export const AddCrossModal = ({
  article,
  brandId,
  cross,
  analogueCode,
  openModal,
  setOpenModal,
  getAndSetCross
}) => {
  const [loading, setLoading] = useState(false);

  console.log(analogueCode);

  const crossHandler = (values, resetForm) => {
    const analogueCodes = [];
    cross.forEach(v => {
      if (!analogueCodes.find(vv => vv === v.analogueCode?.id)) {
        analogueCodes.push(v.analogueCode?.id);
      }
    });

    if (!analogueCode && analogueCodes.length > 1) {
      toast.error("Выберите бренд, иначе неоднозначный список кодов аналогов");
      return;
    }

    setLoading(true);

    if (!analogueCode && cross.length === 0) {

      if (!brandId) {
        toast.error('Нужно выбрать Бренд');
        setLoading(false);
        return;
      }

      if (!article) {
        toast.error('Нужно ввести Артикур');
        setLoading(false);
        return;
      }

      createCross({
        brandId: brandId,
        article: article,
        articleAnalog: values?.article,
        brandAnalogId: values?.brand?.id
      })
        .then((res) => {
          toast.success("Кросс успешно добавлен");
          resetForm();
          getAndSetCross();
          setOpenModal(false);
        })
        .catch((e) => {
          toast.error(e.response?.data?.message);
        })
        .finally(() => setLoading(false));

      return;
    }

    createCross({
      brandId: values?.brand?.id,
      article: values?.article,
      analogueCodeId: analogueCode || (cross.length > 0 ? cross[0].analogueCode?.id : null)
    })
      .then((res) => {
        getAndSetCross();
        toast.success("Кросс успешно добавлен");
        setOpenModal(false);
        resetForm();
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      isOpen={openModal}
      toggle={() => setOpenModal(false)}
    >
      {loading && <MySpinner overlay />}
      <ModalHeader>
        <div className="modal-title-text">Добавление нового кросса</div>
        <CloseButton onClick={() => setOpenModal(false)} />
      </ModalHeader>
      <ModalBody className="m-3">
        <Formik
          initialValues={{
            article: "",
            brand: null,
          }}
          validationSchema={CrossSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            crossHandler(values, resetForm);
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Row className="main-info">
                <Col>
                  <FormGroup>
                    <Label>Артикул</Label>
                    <Input
                      id="article"
                      label="Артикул"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.article}
                      invalid={
                        errors.article && touched.article ? errors.article : null
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="main-info">
                <Col>
                  <FormGroup>
                    <Label>Бренд</Label>
                    <SelectSearch
                      name="brand"
                      placeholder="Выберите бренд"
                      functionSuggestion={brandsSuggestion}
                      value={values.brand}
                      setValue={val => setFieldValue("brand", val)}
                      isClearable
                      invalid={
                        errors.brand && touched.brand ? errors.brand : null
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button type="submit" color="primary" className="mr-2">
                  Добавить
                </Button>
                <Button type="button" onClick={() => setOpenModal(false)} color="secondary">
                  Закрыть
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};
